/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingMelcoModelsBoolResponse
 */
export interface TrackingMelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TrackingMelcoModelsBoolResponse
     */
    result?: boolean;
}

export function TrackingMelcoModelsBoolResponseFromJSON(json: any): TrackingMelcoModelsBoolResponse {
    return TrackingMelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function TrackingMelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function TrackingMelcoModelsBoolResponseToJSON(value?: TrackingMelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


